// lbl.example.
export const example = {
    monthPicker: {
        name: 'เดือน/ปี',
        placeholder: '',
        required: 'กรุณาเลือกเดือน/ปี',
        too_short: '',
        invalid: '',
        month: {
            name: '',
            placeholder: 'เดือน',
            required: ' '
        },
        year: {
            name: '',
            placeholder: 'ปี',
            required: ' '
        },
    },
}
